export default __webpack_public_path__ + "static/media/Elena Z 2.90417c2d.png";